import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:12
* @route '/app/member/payments/{payment}/receipt'
*/
export const receipt = (args: { payment: number | { id: number } } | [payment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: receipt.url(args, options),
    method: 'get',
})

receipt.definition = {
    methods: ["get","head"],
    url: '/app/member/payments/{payment}/receipt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:12
* @route '/app/member/payments/{payment}/receipt'
*/
receipt.url = (args: { payment: number | { id: number } } | [payment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { payment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            payment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment: typeof args.payment === 'object'
        ? args.payment.id
        : args.payment,
    }

    return receipt.definition.url
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:12
* @route '/app/member/payments/{payment}/receipt'
*/
receipt.get = (args: { payment: number | { id: number } } | [payment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: receipt.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:12
* @route '/app/member/payments/{payment}/receipt'
*/
receipt.head = (args: { payment: number | { id: number } } | [payment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: receipt.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:12
* @route '/app/member/payments/{payment}/receipt'
*/
const receiptForm = (args: { payment: number | { id: number } } | [payment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: receipt.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:12
* @route '/app/member/payments/{payment}/receipt'
*/
receiptForm.get = (args: { payment: number | { id: number } } | [payment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: receipt.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:12
* @route '/app/member/payments/{payment}/receipt'
*/
receiptForm.head = (args: { payment: number | { id: number } } | [payment: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: receipt.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

receipt.form = receiptForm

const payments = {
    receipt: Object.assign(receipt, receipt),
}

export default payments